export default "__VITE_ASSET__66b2abc6__"